"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sihuaLu: 'Lộc',
    sihuaQuan: 'Quyền',
    sihuaKe: 'Khoa',
    sihuaJi: 'Kỵ',
};
